export type Void = void;

export const Void: { type: 'Void'; name: 'Void'; node?: never } = {
  type: 'Void',
  name: 'Void',
};
